/**
 *
 * Awards Block
 *
 * Handling awards lightbox
 */

 jQuery(document).ready(function ($) {

    let hideForm = window.localStorage.getItem('livestreams_gate_complete');

    if(hideForm) {
        $('.itbl-livestream-form').hide(0);
    } else {
        $('.itbl-livestream-form').show(300);
    }

	$('.js-livestream-btn').on('click', function(e) {
		e.preventDefault();

        var form = $(this).attr('data-form');

        $('.js-livestream-form-welcome').addClass('hidden');
        $('.js-livestream-form-'+form).removeClass('hidden'); 
	});

    $('.js-livestream-form-back').on('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('js-form-login')) {
            $('.js-livestream-form-login').addClass('hidden');
            document.getElementsByClassName('js-form-livestream-login')[0].reset();
        } else {
            $('.js-livestream-form-register').addClass('hidden');
            document.getElementsByClassName('js-form-livestream-register')[0].reset();
        }

        $('.js-livestream-form-welcome').removeClass('hidden');
    });

    // Submitting the form
    $('.js-form-livestream-gate').on('submit', function (e) {
        e.preventDefault();
        let that = $(this);
        let register = false;
        let formValid = true;
        let userAgreed = false;

        if(that.hasClass('js-form-livestream-register')){
           register = true;
        }

        let data = that.serializeArray();
        
        let validateInputs = [];
        
        if(register) {
            validateInputs = ['FirstName', 'LastName', 'Email', 'Company', 'Title', 'CX_Persona__c', 'Country'];
            userAgreed = document.querySelectorAll('.js-agree-checkbox-register > input')[0].checked;
        } else {
            validateInputs = ['FirstName', 'LastName', 'Email', 'Country' ];
            userAgreed = document.querySelectorAll('.js-agree-checkbox-login > input')[0].checked;
        }

        data.forEach(element => {
            if(validateInputs.includes(element.name) && !element.value) {
                formValid = false;
            }
        });

        if(formValid && userAgreed) {
            let validData = that.serializeArray().reduce((acc, x) => {
              acc[x.name] = x.value
              return acc
            }, {});
            
            if (window.marketoSubmit) {
              window.marketoSubmit(validData, null)
                .catch(function () { console.log('marketoSubmit failed'); })
                .finally(function () {
                  successCB()
                });
            }

            function successCB() {
                that[0].reset();

                window.localStorage.setItem('livestreams_gate_complete', true);
                
                if(register) {
                    $('.js-livestream-form-register').addClass('hidden');
                    $('.js-livestream-form-confirm-register').removeClass('hidden');
                } else {
                    $('.js-livestream-form-login').addClass('hidden');
                    $('.js-livestream-form-confirm-login').removeClass('hidden');
                }

                setTimeout(function () {
                $('.itbl-livestream-form').hide(300);
                }, 1000);
            }
        }
    });
	
});
